require('./myProfileSecurityKitResume.scss');
// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ components
const { EmptyState } = require('commonsComponents/emptyState');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { KitsResume } = require('components/myProfile/myProfileSecurityKitChange/myProfileSecurityKitResume/kitsResume/kitsResume')

class MyProfileSecurityKitResume extends React.PureComponent {

	constructor(props) {
		super(props);

        this.state = {
            sets: props.immMyProfileSecurityKitChange.get('sets'),
			referenceKits: props.immMyProfileSecurityKitChange.get('referenceKits'),
			securityKitGetKitIsFetching: props.immMyProfileSecurityKitChange.get('securityKitGetKitIsFetching'),
			errorReceived: props.immMyProfileSecurityKitChange.get('errorReceived'),
        }
	}

	componentWillReceiveProps(nextProps) {
		const { immMyProfileSecurityKitChange } = nextProps;
		this.setState({
			sets: immMyProfileSecurityKitChange.get('sets'),
			referenceKits: immMyProfileSecurityKitChange.get('referenceKits'),
			securityKitGetKitIsFetching: immMyProfileSecurityKitChange.get('securityKitGetKitIsFetching'),
			errorReceived: immMyProfileSecurityKitChange.get('errorReceived'),
      })
    }

    buildButton = () => {
        const { handleEditButtonClick } = this.props;
        const {securityKitGetKitIsFetching, errorReceived } = this.state;
        if(errorReceived !== '') return null
        return (
            <OKButton
                onClick={() => handleEditButtonClick()}
                modifier="secondary"
                disabled={securityKitGetKitIsFetching || errorReceived !== ''} >
                <FormattedText value={`securityKit-buttonResume`}/>
            </OKButton>
        );
    }

    renderKitResume () {
        const { isNerudaUser } = this.props;
        const { sets, referenceKits } = this.state;
        const button = this.buildButton();
        const tooltipTarget = <i className="icon icon-pregunta" />;
        const infoTextResumeValue = isNerudaUser ? 'securityKit-securityKit_infoTextResumeNerudaUser' : 'securityKit-infoTextResume';
        const tooltipInfoTextResumeContent = isNerudaUser ? 'securityKit-securityKit_tooltipInfoTextResumeNerudaUser' : 'securityKit-tooltipInfoTextResume';

        return (
            <div>
                <div className="col-xs-6 my-profile-security-kit-resume__header-button">
                    {button}
                </div>
                <div className="my-profile-security-kit-resume__section-container col-xs-12">
                    <div className="my-profile-security-kit-resume__section-container__title">
                        <FormattedText value={`securityKit-titleSectionResume`} />
                    </div>
                </div>
                <div className="my-profile-security-kit-resume__info-text col-xs-12">
                    <FormattedText value={infoTextResumeValue} />
                    <OKTooltip
                        content={tooltipInfoTextResumeContent}
                        offset={[0, -15]}
                        target={tooltipTarget}
                    />
                </div>
                <div className="col-xs-12">
                    <KitsResume
                        sets={sets}
                        referenceKits={referenceKits}
                    />
                </div>
                <div className="my-profile-security-kit-resume__change-button-container col-xs-12">
                    <div>
                        {button}
                    </div>
                </div>
            </div>
        )
    }
    render() {
        const { securityKitGetKitIsFetching, errorReceived } = this.state;
        return(
            <div>
                <ContentBox>
                    <div className="my-profile-security-kit-resume row">
                        <div className="col-xs-6">
                            <OKBoxTitle value={formatText('securityKit-titleResumeView')} />
                        </div>
                        {
                            securityKitGetKitIsFetching ?
                                <div className="col-xs-12">
                                    <LoadingSection/>
                                </div>
                            :
                                !securityKitGetKitIsFetching && errorReceived !== '' ?
                                    <div className="col-xs-12">
                                        <EmptyState
                                            primaryText={formatText('securityKit-messageError')}
                                            iconType="nointernet-banking"
                                        />
                                    </div>
                                :
                                    this.renderKitResume()
                        }
                    </div>
                </ContentBox>
            </div>
        )
    }
}

MyProfileSecurityKitResume.propTypes = {
	immMyProfileSecurityKitChange: PropTypes.object.isRequired,
    handleEditButtonClick: PropTypes.func.isRequired,
    isNerudaUser: PropTypes.bool.isRequired,
}

module.exports.constructor = MyProfileSecurityKitResume
module.exports.MyProfileSecurityKitResume = MyProfileSecurityKitResume
